import { z } from 'zod';

export const jobStatusSchema = z.enum(['queued', 'running', 'completed', 'failed', 'noData']);

export type JobStatus = z.infer<typeof jobStatusSchema>;

const closedJobStatuses = new Set<JobStatus>(['completed', 'failed', 'noData']);

export const isClosedJobStatus = (status: JobStatus) => closedJobStatuses.has(status);
